// src/components/LogoutModal/LogoutModal.tsx
import React from 'react';
import { LogOut, X, AlertTriangle } from 'lucide-react';
import './LogoutModal.scss';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="logout-modal-overlay" onClick={handleBackdropClick}>
      <div className="logout-modal">
        <button className="logout-modal-close" onClick={onClose} disabled={loading}>
          <X size={20} />
        </button>

        <div className="logout-modal-icon">
          <div className="logout-icon-wrapper">
            <LogOut size={48} />
          </div>
          <div className="logout-warning-badge">
            <AlertTriangle size={20} />
          </div>
        </div>

        <div className="logout-modal-content">
          <h2>Logout Confirmation</h2>
          <p>Are you sure you want to logout? You will need to sign in again to access your account.</p>
        </div>

        <div className="logout-modal-actions">
          <button
            className="logout-btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="logout-btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="logout-spinner"></span>
                Logging out...
              </>
            ) : (
              <>
                <LogOut size={18} />
                Yes, Logout
              </>
            )}
          </button>
        </div>

        <div className="logout-modal-footer">
          <p>This action will clear your session and local data.</p>
        </div>
      </div>
    </div>
  );
};
